/* eslint "react-hooks/exhaustive-deps": "off" */
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import BarGraph from "@components/graphStatistics/Bar/Graphs";
import DefaultDatePicker from "@components/arhDatePicker/DefaultDatePicker";
import { parseValidNumber } from "@helpers/_functions";
import { useReduxSelector } from "@hooks/useReduxSelector";
import { employeStatisticsActions } from "@store/actions";

const monthList = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre"
];

const graphOptions = {
  tooltips: {
    bodyFontSize: 15,
    caretSize: 8,
    titleFontSize: 13
  },
  scales: {
    yAxes: [
      {
        ticks: {
          precision: 0
        }
      }
    ],
    xAxes: [
      {
        maxBarThickness: 50
      }
    ]
  },
  legend: {
    display: false
  }
};


export default function RoulementGraph({ rotation, rotationYear }) {
  const reduxDispatch = useDispatch();
  const { t: statTranslator } = useTranslation("pages.employés.statistics");
  const referenceDate = useReduxSelector(
    ({ enterpriseEmployeData }) =>
      enterpriseEmployeData.employeStatistics.pagination?.referenceDate || null
  );
  const isLoadingEmployeStatistics = useReduxSelector(
    ({ enterpriseEmployeData }) =>
      enterpriseEmployeData.employeStatistics.isLoading
  );

  const [graphData, setGraphData] = useState({});

  function onChangeReferenceDate(value) {
    reduxDispatch(
      employeStatisticsActions.filterData({
        pagination: {
          referenceDate: value ? moment(value).format("YYYY-MM-DD") : null
        }
      })
    );
  }

  const buildLabel = (item, index) => {
    const key = item?._id || item?.month;

    if (typeof key === "string" && /^\d{4}-\d{2}$/.test(key)) {
      const parsed = moment(key, "YYYY-MM", true);
      if (parsed.isValid()) {
        return `${statTranslator(monthList[parsed.month()])} ${parsed.year()}`;
      }
    }

    if (typeof key === "string" && /^\d{2}$/.test(key)) {
      const monthIndex = parseInt(key, 10) - 1;
      if (monthIndex >= 0 && monthIndex < 12) {
        return `${statTranslator(monthList[monthIndex])} ${rotationYear}`;
      }
    }

    return `${statTranslator(monthList[index] || "")}${rotationYear ? ` ${rotationYear}` : ""}`;
  };

  useEffect(() => {
    const baseSeries =
      rotation?.employePerMonth?.length
        ? rotation.employePerMonth
        : rotation?.hiringDates?.length
          ? rotation.hiringDates
          : rotation?.endDates || [];

    const dataRoulement = {
      labels:
        baseSeries.length > 0
          ? baseSeries.map((item, index) => buildLabel(item, index))
          : monthList.map((month) => `${statTranslator(month)} ${rotationYear}`),

      datasets: [
        // Supposons nombre employer: 50
        {
          label: statTranslator("Départ"),
          backgroundColor: "#FE6383",
          data: rotation?.endDates?.map((_item) => _item?.count) || [],
          stack: 1
        },
        {
          label: statTranslator("Embauche"),
          backgroundColor: "#37A1EB",
          data: rotation?.hiringDates?.map((_item) => _item?.count) || [],
          stack: 1
        },
        {
          label: statTranslator("Nombre total"),
          backgroundColor: "transparent",
          pointBackgroundColor: "#4cc0c0",
          pointBorderWidth: 2,
          borderColor: "#4cc0c0",
          data: rotation?.employePerMonth?.map((_item) => _item?.count) || [],
          // stack: 1,
          type: "line"
        }
      ]
    };

    setGraphData(dataRoulement);
  }, [rotation, rotationYear, statTranslator]);

  function onChangeReferenceDate(value) {
    reduxDispatch(
      employeStatisticsActions.filterData({
        pagination: {
          referenceDate: value ? moment(value).format("YYYY-MM-DD") : null
        }
      })
    );
  }

 

  return (
    <BarGraph
      legends={
        <div className="arh-flex arh-flex-col arh-space-y-2">
          <div className="arh-flex arh-space-x-3 arh-items-center">
            <span className="arh-w-3 arh-h-3 arh-bg-[#37a1eb]"></span>
            <span className="arh-font-poppins arh-text-xs arh-text-darkColor arh-font-medium">
              {statTranslator("Embauches")}
            </span>
          </div>
          <div className="arh-flex arh-space-x-3 arh-items-center">
            <span className="arh-w-3 arh-h-3 arh-bg-[#fe6383]"></span>
            <span className="arh-font-poppins arh-text-xs arh-text-darkColor arh-font-medium">
              {statTranslator("Départ")}
            </span>
          </div>
        </div>
      }
      graphData={graphData}
      title={statTranslator("Roulement")}
      graphOptions={graphOptions}
      target="rotation"
      anotherClass="desktop-mini:arh-w-[31rem]"
      description={
        <>
          <div className="flex-column calendar_with_btn employerThemeDatePicker wadeDatePicker arh-flex arh-w-4/5">
            <label
              className="arh-mb-1 arh-w-full arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor"
            >
              {statTranslator("Date de référence")}
            </label>
            <DefaultDatePicker
              className="focus_green dateOfBirth"
              name="selectedDate"
              placeholder="Date"
              dateValue={referenceDate || new Date()}
              setDateValue={onChangeReferenceDate}
              classPosition="calendar_right"
              readOnly={isLoadingEmployeStatistics}
              showReset={Boolean(referenceDate)}
            />
          </div>
          <div className="arh-text-base arh-font-medium">{statTranslator("Taux")}</div>
          <table className="arh-text-xs">
            <tbody>
              {rotation?.details?.map((_detail, index) => {
                const detail = _detail?.period.split(" ");
                return (
                  <tr key={_detail?._id || `${_detail?.period || "period"}-${index}`}>
                    <td className="arh-p-1">
                      {detail?.[0]} {statTranslator(detail?.[1])}:
                    </td>
                    <td className="arh-text-[#859298] arh-p-1">
                      {parseValidNumber(_detail?.percentProgress * 100)} %
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      }
    />
  );
}
